import { PUSH_NAV_HISTORY, BACK, RESTORE_COMPLETE, SET_HEADER_VISIBLE } from './actions'

const initialState = {
  history: [],
  pendingRestore: null,
  headerHidden: false
}

export default function mundialReducer (state, action) {
  if (state === undefined) state = initialState

  switch (action.type) {
    case PUSH_NAV_HISTORY:
      return {
        ...state,
        history: [...state.history, action.payload],
        pendingRestore: null
      }

    case BACK: {
      if (state.history.length === 0) return state
      const pendingRestore = state.history[state.history.length - 1]
      return {
        ...state,
        history: state.history.slice(0, -1),
        pendingRestore: pendingRestore
      }
    }

    case RESTORE_COMPLETE:
      return {
        ...state,
        pendingRestore: null
      }

    case SET_HEADER_VISIBLE:
      return {
        ...state,
        headerHidden: !action.payload
      }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/store/reducer.js